export default {
    Title: 'Tham số báo cáo',
    Year: 'Năm',
    All: 'Tất cả',
    Summary: 'Tổng hợp',
    Option: 'Tùy chọn',
    BudgetSourceProperty: 'Nguồn kinh phí',
    DecisionNo: 'Kèm theo QĐ số',
    DecisionDate: 'Ngày',
    DecisionBy: 'Của',
    SelectAll: '<<Tất cả>>',
  };
  